import { graphql } from 'gatsby';
import { Anchor } from '@twilio-paste/anchor';
import { Box } from '@twilio-paste/box';
import { Card } from '@twilio-paste/card';
import { Heading } from '@twilio-paste/heading';
import { Paragraph } from '@twilio-paste/paragraph';
import { Text } from '@twilio-paste/text';
import { Separator } from '@twilio-paste/separator';
import { UnorderedList, ListItem } from '@twilio-paste/list';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@twilio-paste/tabs';
import { Table, THead, TBody, Td, Th, Tr } from '@twilio-paste/table';
import { SiteLink } from "../../../../src/components/SiteLink.tsx";
import { Breadcrumb, BreadcrumbItem } from "../../../../src/components/breadcrumb";
import { SidebarCategoryRoutes } from "../../../../src/constants";
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import * as React from 'react';
export default {
  graphql,
  Anchor,
  Box,
  Card,
  Heading,
  Paragraph,
  Text,
  Separator,
  UnorderedList,
  ListItem,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Table,
  THead,
  TBody,
  Td,
  Th,
  Tr,
  SiteLink,
  Breadcrumb,
  BreadcrumbItem,
  SidebarCategoryRoutes,
  Callout,
  CalloutTitle,
  CalloutText,
  React
};